import { render, staticRenderFns } from "./FormulationQaTab.vue?vue&type=template&id=1c88a8d8&scoped=true&"
import script from "./FormulationQaTab.vue?vue&type=script&lang=js&"
export * from "./FormulationQaTab.vue?vue&type=script&lang=js&"
import style0 from "./FormulationQaTab.vue?vue&type=style&index=0&id=1c88a8d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c88a8d8",
  null
  
)

export default component.exports